import { AuthLibMode, AuthLibSettings } from '@mamdev/fd.libs.oauth2-client'
import { getStage } from './util/stage'
import { getOauthEndpoints } from './util/oauth-endpoints'
import { AuthModeType, getOauthCredentials } from './util/oauth-credentials'
import { getSearchParams } from './util/search-params'
import { getBrand } from './util/brand'
import * as logger from '@mamdev/navigator.frontend-logger'
import { xUiApp } from './util/xuiapp'
import { getUrlParam } from './util/url-param'

export const OAUTH_SCOPES = ['ppc_permission_w', 'login_webshop', 'hsp_user_full_access']

export async function getAuthLibConfig(): Promise<AuthLibSettings> {
  const section = getUrlParam('section')
  const stage = getStage()
  let navsid = getUrlParam('navsid')
  const lightmailerDc = getUrlParam('session_dc')

  let mode: AuthLibMode
  let authMode: AuthModeType = 'standalone';
  if (section.indexOf('navigator') !== -1) {
    mode = AuthLibMode.PASSPORT
    authMode = 'navigator'
  } else if (section.indexOf('poseidon_light') !== -1) {
    mode = AuthLibMode.BRIDGE_SOLUTION
    navsid = 'none'
    if (lightmailerDc === 'bap') {
      authMode = 'lightmailer-bap'
    } else if (lightmailerDc === 'bs') {
      authMode = 'lightmailer-bs'
    }
  } else {
    mode = AuthLibMode.STANDALONE
  }

  logger.debug('authMode', authMode)
  const oauthCredentials = await getOauthCredentials(getBrand(), stage, 'login', authMode)

  let scopes = OAUTH_SCOPES
  if (stage === 'dev') {
    scopes = ['dev']
  }

  const origin = `${location.protocol}//${location.host}`
  const redirectUri = `${origin}${mode === 'standalone' ? '' : '/_auth/index.html'}`

  const oauthEndpoints = getOauthEndpoints()

  const settings: AuthLibSettings = {
    mode,
    clientId: oauthCredentials.clientId,
    clientSecret: oauthCredentials.clientSecret,
    scopes,
    deviceName: 'workstation',
    xUiApp,
    authCode: getSearchParams().get('code'),
    oauthEndpointToken: oauthEndpoints.oauthEndpointToken,
    navsid,
    enableAutoRefresh: false
  }

  if (mode === AuthLibMode.BRIDGE_SOLUTION || mode === AuthLibMode.STANDALONE) {
    settings.oauthEndpointAuthorize = oauthEndpoints.oauthEndpointAuthorize
    settings.redirectUri = redirectUri
  }

  logger.debug('Using AuthLib settings:', JSON.stringify(settings, null, 2))
  return settings
}
